<template>
  <b-modal
    id="event-modal"
    ref="event-modal"
    @show="getPosition"
    @hide="resetModal"
    :title="type == 'edit' ? 'Cập nhật sự kiện' : 'Tạo sự kiện'"
    size="xl"
  >
    <b-container fluid class="p-0">
      <b-overlay :show="loading">
        <div v-if="type == 'edit'" class="mb-4">
          <span class="label label-lg label-light-success label-inline">
            Đã đăng ký tham gia: {{ eventJoinCount }} người
          </span>
        </div>
        <b-form-group v-if="form.infoLink" label="Link thông tin sự kiện" class="mb-4">
          <b-input-group>
            <b-form-input :value="form.infoLink" readonly></b-form-input>
            <template #append>
              <b-button variant="outline-secondary" @click="copyInfoLink">
                <span class="svg-icon">
                  <inline-svg src="/media/svg/icons/Neolex/Basic/copy.svg" />
                </span>
              </b-button>
            </template>
          </b-input-group>
        </b-form-group>
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-row>
            <b-col>
              <b-row>
                <b-col style="min-height: 170px">
                  <label class="d-block text-center"> Hình ảnh </label>
                  <label
                    class="d-flex flex-column align-items-center justify-content-center"
                  >
                    <span style="font-size: 10px">Kích thước 184x108</span>
                  </label>
                  <div class="image-wrapper">
                    <v-file-input
                      hide-input
                      v-model="file"
                      accept="image/png, image/jpeg, image/bmp"
                      class="icon-edit"
                      @change="onUpload"
                      prepend-icon="mdi-pencil-outline"
                      truncate-length="15"
                    >
                    </v-file-input>
                    <v-img :src="preview" :aspect-ratio="1 / 1"></v-img>
                  </div>
                </b-col>
                <b-col style="min-height: 170px">
                  <label class="d-block text-center">Banner</label>
                  <label
                    class="d-flex flex-column align-items-center justify-content-center"
                  >
                    <span style="font-size: 10px">Kích thước 375x340</span>
                  </label>
                  <div class="image-wrapper">
                    <v-file-input
                      hide-input
                      v-model="fileBanner"
                      accept="image/png, image/jpeg, image/bmp"
                      class="icon-edit"
                      @change="onUploadBanner"
                      prepend-icon="mdi-pencil-outline"
                      truncate-length="15"
                    >
                    </v-file-input>
                    <v-img :src="previewBanner" :aspect-ratio="1 / 1"></v-img>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <basic-input
                label="Tiêu đề"
                placeholder="Tiêu đề"
                name="title"
                :required="true"
                :value.sync="form.title"
                data-vv-as="Tiêu đề"
                v-validate="'required'"
                :state="validateState('title')"
                :invalidFeedback="errors.first('title')"
              ></basic-input>
            </b-col>
            <b-col cols="6">
              <basic-select
                label="Bác sĩ"
                placeholder="Chọn bác sĩ"
                name="doctor"
                :required="true"
                data-vv-as="Bác sĩ"
                :state="validateState('doctor')"
                :invalidFeedback="errors.first('doctor')"
                :options="doctorOptions"
                :value.sync="form.accountId"
                :allowEmpty="false"
                value-label="text"
                track-by="value"
              />
            </b-col>
            <b-col cols="6">
              <basic-input
                label="Chức danh bác sĩ"
                placeholder="Để trống sẽ lấy theo Docosan"
                name="doctorTitle"
                :value.sync="form.doctorTitle"
              ></basic-input>
            </b-col>
            <b-col cols="6">
              <basic-select
                label="Trạng thái"
                name="status"
                :required="true"
                placeholder="Chọn trạng thái"
                v-validate="'required'"
                data-vv-as="Trạng thái"
                :state="validateState('status')"
                :invalidFeedback="errors.first('status')"
                :options="statusOptions"
                :value.sync="form.status"
                :solid="false"
                :allowEmpty="false"
              />
            </b-col>
            <b-col cols="6">
              <basic-select
                :required="true"
                label="Chủ đề"
                class="lesson-edit-page__dropdown-filter"
                placeholder="---Chọn chủ đề---"
                name="module"
                :solid="false"
                :value.sync="form.module"
                :options="moduleOptions"
                value-label="text"
                track-by="value"
                :state="validateState('module')"
                :invalidFeedback="errors.first('module')"
                v-validate="'required'"
                data-vv-as="Chủ đề"
                @update:value="selected($event, 'module', moduleOptions)"
              />
            </b-col>
            <b-col cols="6">
              <basic-select
                :required="true"
                label="Hình thức sự kiện"
                class="lesson-edit-page__dropdown-filter"
                placeholder="Hình thức sự kiện"
                name="eventType"
                :solid="false"
                v-model="form.eventType"
                :options="eventTypeOptions"
                value-label="text"
                track-by="value"
                :state="validateState('eventType')"
                :invalidFeedback="errors.first('eventType')"
                v-validate="'required'"
                data-vv-as="Hình thức sự kiện"
                @update:value="selected($event, 'eventType', eventTypeOptions)"
              />
            </b-col>
            <b-col cols="6">
              <basic-input
                :label="
                  form.eventType === true
                    ? 'Địa điểm tổ chức sự kiện'
                    : 'Link tham gia sự kiện'
                "
                :placeholder="
                  form.eventType === true
                    ? 'Địa điểm tổ chức sự kiện'
                    : 'Link tham gia sự kiện'
                "
                name="link"
                :required="true"
                :value.sync="form.link"
                :data-vv-as="
                  form.eventType === true
                    ? 'Địa điểm tổ chức sự kiện'
                    : 'Link tham gia sự kiện'
                "
                v-validate="'required'"
                :state="validateState('link')"
                :invalidFeedback="errors.first('link')"
              ></basic-input>
              <small
                v-if="isEventDirect && address"
                class="text-success d-block mt-2"
              >
                <strong>Địa chỉ nhận diện:</strong> {{ address }}
              </small>
              <small
                v-if="isEventDirect && form.link && !address && loading"
                class="text-info d-block mt-2"
              >
                Đang tải địa chỉ...
              </small>
              <small
                v-if="
                  isEventDirect && form.link && address === 'Lỗi lấy địa chỉ'
                "
                class="text-danger d-block mt-2"
              >
                Không thể lấy địa chỉ từ link này
              </small>
            </b-col>
            <b-col cols="6">
              <basic-date-picker
                v-model="form.eventDate"
                label="Ngày diễn ra sự kiện"
                placeholder="Chọn ngày"
                name="eventDate"
                format="DD/MM/YYYY"
                type="date"
                :required="true"
                v-validate="'required'"
              />
            </b-col>
            <b-col cols="6">
              <label
                >Thời gian nhắc nhở <span class="text-danger">*</span></label
              >
              <b-form-timepicker
                v-model="form.eventTime"
                name="eventTime"
                :data-vv-as="'Giờ diễn ra sự kiện'"
              />
            </b-col>
            <b-col cols="6">
              <basic-input
                label="Thời gian kết thúc"
                placeholder="Ví dụ: 48 (2 ngày)"
                name="duration"
                :required="true"
                :value.sync="form.duration"
                data-vv-as="Thời gian kết thúc"
                v-validate="'required'"
                :state="validateState('duration')"
                :invalidFeedback="errors.first('duration')"
              ></basic-input>
            </b-col>
            <b-col cols="6">
              <basic-select
                :required="true"
                label="Bài học"
                class="lesson-edit-page__dropdown-filter"
                placeholder="Bài học"
                name="lesson"
                :solid="false"
                :value.sync="form.lesson"
                :options="lessonOptions"
                value-label="text"
                track-by="value"
                :state="validateState('lesson')"
                :invalidFeedback="errors.first('lesson')"
                v-validate="'required'"
                data-vv-as="Chủ đề"
                @update:value="selected($event, 'lesson', lessonOptions)"
              />
            </b-col>
            <b-col cols="12">
              <b-row>
                <b-col cols="6">
                  <b-form-group label="Chiến dịch giới hạn hiển thị" class="mb-4">
                    <basic-select
                      placeholder="Không giới hạn - ai cũng xem được"
                      name="restrictedCampaign"
                      :solid="false"
                      :value.sync="form.restrictedCampaign"
                      :options="campaignOptions"
                      value-label="text"
                      track-by="value"
                    />
                    <small class="text-muted d-block mt-1">
                      Chọn 1 chiến dịch thì sự kiện chỉ hiển thị cho người có số điện thoại nằm trong
                      danh sách khách hàng của chiến dịch đó. Để trống thì ai cũng xem được như bình thường.
                    </small>
                  </b-form-group>
                </b-col>
                <b-col v-if="type == 'edit'" cols="6">
                  <b-form-group label="Tạo nhắc nhở cho chiến dịch doanh nghiệp" class="mb-4">
                    <b-button
                      variant="success"
                      :disabled="!form.restrictedCampaign || notifyingCampaign"
                      @click="createCampaignReminder"
                    >
                      Tạo nhắc nhở
                    </b-button>
                    <small class="text-muted d-block mt-1">
                      Dùng chung chiến dịch đã chọn ở ô "Chiến dịch giới hạn hiển thị" bên trái.
                    </small>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12">
              <label>Từ khóa</label>
              <multiselect
                :options="tagOptions"
                placeholder="Tìm kiếm hoặc tạo keyword mới"
                tag-placeholder="Thêm từ khóa"
                select-label=""
                selected-label="Đã chọn"
                deselect-label="Bỏ chọn"
                label="text"
                track-by="value"
                v-model="form.tags"
                multiple
                taggable
                @tag="onAddTag"
              />
            </b-col>
            <b-col cols="12">
              <b-form-group
                class="required"
                :required="true"
                :state="validateState('position')"
                :invalidFeedback="errors.first('position')"
              >
                <template v-slot:label>
                  Vị trí hiển thị gợi ý:<span class="text-danger">*</span>
                </template>
                <b-form-checkbox-group
                  class="required"
                  name="position"
                  :required="true"
                  v-validate="'required'"
                  v-model="position"
                  :options="options"
                  :state="validateState('position')"
                  :invalidFeedback="errors.first('position')"
                  data-vv-as="Vị trí hiển thị gợi ý"
                ></b-form-checkbox-group>
              </b-form-group>
            </b-col>
            <b-col>
              <vue-editor
                id="editor"
                useCustomImageHandler
                @image-added="handleImageAdded"
                v-model="form.content"
              >
              </vue-editor>
            </b-col>
          </b-row>
        </form>
      </b-overlay>
    </b-container>
    <template #modal-footer>
      <div class="w-100 d-flex align-items-center justify-content-end">
        <b-button
          class="btn btn-plain ml-2"
          href="#"
          :disabled="loading"
          @click.stop="handleCancel"
          tabindex="0"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
          </span>
          Huỷ
        </b-button>
        <b-button
          class="btn btn-success ml-2"
          href="#"
          :disabled="loading"
          @click.stop="handelValidation"
          tabindex="0"
        >
          <span class="svg-icon">
            <inline-svg src="/media/svg/icons/Neolex/Basic/save.svg" />
          </span>
          {{ type == 'edit' ? 'Cập nhật' : 'Tạo' }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import { VueEditor } from 'vue2-editor';

export default {
  name: 'Modal',
  components: {
    Multiselect,
    VueEditor,
  },
  props: {
    popupType: {
      type: String,
      default: 'create',
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      doctorOptions: [],
      position: null,
      file: null,
      fileBanner: null,
      preview: null,
      previewBanner: null,
      form: {
        link: '',
        content: null,
        module: null,
        tags: [],
        eventType: null,
        eventDate: null,
        eventTime: null,
        accountId: null,
        doctorTitle: '',
        infoLink: '',
        restrictedCampaign: null,
      },
      loading: false,
      options: [],
      statusOptions: [
        { name: 'Không hoạt động', id: 0 },
        { name: 'Hoạt động', id: 1 },
      ],
      eventTypeOptions: [
        { text: 'Trực tuyến', value: false },
        { text: 'Trực tiếp', value: true },
      ],
      moduleOptions: [],
      lessonOptions: [],
      tagOptions: [],
      originalAccountId: null,
      address: null,
      isLoadingData: false,
      eventJoinCount: 0,
      justCreatedId: null,
      campaignOptions: [],
      notifyingCampaign: false,
    };
  },
  watch: {
    id: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.loadData(newVal);
        }
      },
    },
    'form.link'(newVal) {
      if (this.isLoadingData) return;
      if (this.isEventDirect && newVal) {
        this.fetchAddress(newVal);
      } else {
        this.address = null;
      }
    },

    'form.eventType'() {
      if (this.isLoadingData) return;
      if (this.isEventDirect && this.form.link) {
        this.fetchAddress(this.form.link);
      } else {
        this.address = null;
      }
    },
    'form.accountId'(newVal) {
      if (newVal && typeof newVal === 'object' && newVal.img) {
        this.preview = newVal.img;
      } else if (newVal) {
        const doctor = this.doctorOptions.find((d) => d.value === newVal.value || d.value === newVal);
        this.preview = doctor?.img || null;
      } else {
        this.preview = null;
      }

      const selectedId = newVal?.value ?? newVal;
      if (selectedId && String(selectedId) !== String(this.originalAccountId)) {
        const doctor = this.doctorOptions.find((d) => String(d.value) === String(selectedId));
        this.form.doctorTitle = doctor?.title || '';
      }
    },
  },
  async mounted() {
    await this.loadPrepareData();
    await this.getDoctor();
    await this.getLessons();
    await this.getCampaigns();
  },
  computed: {
    type() {
      return this.justCreatedId ? 'edit' : this.popupType;
    },
    isEventDirect() {
      if (this.form.eventType === true) return true;
      if (this.form.eventType === false) return false;
      if (this.form.eventType && typeof this.form.eventType === 'object') {
        return this.form.eventType.value === true;
      }
      return false;
    },
  },
  methods: {
    async fetchAddress(link) {
      if (!link) {
        this.address = null;
        return;
      }
      try {
        this.loading = true;
        const data = await this.$api.get(
          `/LearningPost/event/address?mapUrl=${link}`,
        );
        this.address = data || '';
      } catch (error) {
        this.address = 'Lỗi lấy địa chỉ';
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async loadPrepareData() {
      try {
        this.loading = true;
        let apiURI = `/LearningPost/PrepareCreateUpdateFormItem`;
        let resMetadata = await this.$api.get(apiURI);
        let dataMeta = resMetadata.data;
        this.moduleOptions = this.getDropdownOptions(dataMeta.lessonModules);
        this.tagOptions = this.getDropdownOptions(dataMeta.lessonTags);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async getPosition() {
      this.loading = true;
      try {
        let { data } = await this.$api.get('LearningPost/Positions');
        this.options = data.map((e) => ({
          value: `${e.key}`,
          text: e.value,
        }));
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    getDropdownOptions(array) {
      return array.map((item) => {
        return {
          text: item.text,
          value: item.value,
        };
      });
    },
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] = value
        ? optionsArr.find((el) => el.value == value)
        : null;
      if (this.form[formProperty]) {
        this.$validator.reset();
      }

      if (
        formProperty === 'eventType' &&
        this.form[formProperty]?.value === true &&
        this.form.link
      ) {
        this.fetchAddress(this.form.link);
      }
    },
    async loadData(id) {
      try {
        this.isLoadingData = true;
        let { data } = await this.$api.get(`LearningPost/${id}`);
        this.eventJoinCount = data.eventJoinCount || 0;

        await this.getLessons();
        const selectedLesson = data.lessonId
          ? this.lessonOptions.find((e) => e.value === data.lessonId)
          : null;

        if (!this.campaignOptions.length) await this.getCampaigns();
        this.form.restrictedCampaign = data.campaignId
          ? this.campaignOptions.find((e) => e.value === data.campaignId) || null
          : null;

        Object.assign(this.form, {
          id: data.id,
          title: data.title || '',
          content: data.content || null,
          module: data.learningPostModule
            ? {
                text: data.learningPostModule.name,
                value: data.learningPostModule.id,
              }
            : null,
          tags:
            data.learningPostTagMappings?.map((item) => ({
              text: item.name,
              value: item.id,
            })) || [],
          status: this.statusOptions.find((e) => e.id == data.status) || null,
          duration: data.duration || '',
          lesson: selectedLesson || null,
        });
        this.preview = data.imageUrl?.url || null;
        this.previewBanner = data.imageBannerUrl?.url || null;
        this.position = data.positions?.map((e) => `${e.position}`) || [];

        await this.getDoctor();
        const selectedDoctor = this.doctorOptions.find(
          (doc) => String(doc.value) === String(data.accountId),
        );
        this.originalAccountId = data.accountId;
        this.form.accountId = selectedDoctor || null;
        this.form.doctorTitle = data.doctorTitle || '';
        this.preview = selectedDoctor?.img || this.preview;

        this.form.eventType =
          this.eventTypeOptions.find((opt) => opt.value === data.eventType) ||
          null;
        this.form.eventDate = data.eventDate
          ? this.$moment(data.eventDate * 1000).format('DD/MM/YYYY')
          : null;
        this.form.eventTime = data.eventTime || '';
        this.form.link = data.link || '';
        this.form.infoLink = data.infoLink || '';

        if (this.form.eventType?.value === true) {
          await this.fetchAddress(this.form.link);
        }
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.isLoadingData = false;
      }
    },
    onUpload() {
      this.preview = URL.createObjectURL(this.file);
    },
    onUploadBanner() {
      this.previewBanner = URL.createObjectURL(this.fileBanner);
    },
    async handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      const { error, data } = await this.$store.dispatch(
        'context/UPLOAD_IMAGE',
        file,
      );
      if (error) {
        this.$toastr.s({
          title: 'Lỗi !',
          msg: error,
        });
        return null;
      }
      Editor.insertEmbed(cursorLocation, 'image', data.url);
      resetUploader();
    },
    async getDoctor() {
      try {
        this.loading = true;
        const formatDoctors = (raw) => {
          const list = Array.isArray(raw) ? raw : raw?.data || raw?.items || [];

          return list.map((item) => ({
            text: item.name,
            img: item?.avatar || null,
            value: item.id,
            title: [item?.graduate_name, item?.specialty?.[0]?.name]
              .filter((s) => s && String(s).trim())
              .join(' '),
          }));
        };
        const cached = sessionStorage.getItem('doctors');
        if (cached) {
          this.doctorOptions = formatDoctors(JSON.parse(cached));
          return;
        }
        const data = await this.$api.get('/LearningPost/DocosanDoctors');
        sessionStorage.setItem('doctors', JSON.stringify(data));
        this.doctorOptions = formatDoctors(data);
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error?.message || error,
        });
      } finally {
        this.loading = false;
      }
    },
    onAddTag(tag) {
      let newTag = {
        text: tag,
        value: this.$uuid.v1(),
      };
      this.form.tags.push(newTag);
      this.tagOptions.push(newTag);
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    handelValidation() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        this.handleSubmit();
      });
    },
    async getLessons() {
      try {
        this.loading = true;
        let { data } = await this.$api.get(
          '/Lesson?page=1&size=1000&IncludeLessonType=1&IncludeLessonType=2&lessonStateId=1',
        );
        this.lessonOptions = data.map((e) => ({
          value: e.id,
          text: e.name,
        }));
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    async getCampaigns() {
      try {
        const res = await this.$api.get('/BcbCampaign?page=1&size=1000');
        const raw = res?.data ?? res;
        const list = raw?.items ?? raw?.data?.items ?? (Array.isArray(raw) ? raw : []);
        this.campaignOptions = list.map((e) => ({
          value: e.id,
          text: e.name,
        }));
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      }
    },
    async createCampaignReminder() {
      if (!this.form.restrictedCampaign || !this.form.id) return;
      this.notifyingCampaign = true;
      try {
        const campaignId = this.form.restrictedCampaign.value ?? this.form.restrictedCampaign;
        const { data: count } = await this.$api.post(
          `LearningPost/${this.form.id}/NotifyCampaign/${campaignId}`,
        );
        this.$toastr.s({
          title: 'Thành công',
          msg: `Đã thêm ${count} người (có tài khoản app) vào danh sách nhận nhắc sự kiện`,
        });
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: error,
        });
      } finally {
        this.notifyingCampaign = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      if (this.form.accountId !== this.originalAccountId) {
        sessionStorage.removeItem('doctors');
      }
      let positions = [...this.position];
      let payload = new FormData();
      let status =
        this.form.status.id !== undefined && this.form.status.id !== null
          ? this.form.status.id
          : this.form.status;
      payload.append('title', this.form.title);
      payload.append('link', this.form.link ?? '');
      payload.append('image', this.file);
      payload.append('imageBanner', this.fileBanner);
      payload.append('status', status);
      payload.append(
        'eventDate',
        this.form.eventDate
          ? this.$moment(this.form.eventDate, 'DD/MM/YYYY')
              .startOf('day')
              .add(7, 'hours')
              .unix()
          : this.$moment().startOf('day').add(7, 'hours').unix(),
      );
      payload.append('eventTime', this.form.eventTime || '00:00:00');
      payload.append(
        'eventType',
        this.form.eventType?.value ?? this.form.eventType ?? '',
      );
      payload.append('duration', this.form.duration ?? '');
      payload.append('lessonId', this.form.lesson?.value ?? this.form.lesson ?? '');
      payload.append(
        'accountId',
        this.form.accountId?.value ?? this.form.accountId ?? '',
      );
      payload.append('doctorTitle', this.form.doctorTitle?.trim() || '');
      positions.forEach((e, index) => {
        payload.append(`positions[${index}].position`, e);
      });
      if (this.form.tags) {
        this.form.tags.forEach((e, index) => {
          payload.append(`LearningPostTagMappings[${index}].id`, e.value);
          payload.append(`LearningPostTagMappings[${index}].name`, e.text);
        });
      }
      payload.append('lessonModuleId', this.form.module?.value ?? '');
      payload.append('content', this.form.content ?? '');
      payload.append(
        'campaignId',
        this.form.restrictedCampaign?.value ?? this.form.restrictedCampaign ?? '',
      );
      try {
        if (this.type == 'edit') {
          payload.append('id', this.form.id);
          await this.$api.put('LearningPost/Input', payload);
          this.$bvModal.hide('event-modal');
        } else {
          const { data: newId } = await this.$api.post('LearningPost/Input', payload);
          this.$emit('loadData');
          this.justCreatedId = newId;
          this.form.id = newId;
          await this.loadData(newId);
          this.$toastr.s({
            title: 'Thành công !',
            msg: 'Tạo thành công!',
          });
          return;
        }
        this.$emit('loadData');
        this.$toastr.s({
          title: 'Thành công !',
          msg: 'Cập nhật thành công',
        });
      } catch (error) {
        this.$toastr.e({
          title: 'Lỗi !',
          msg: error,
        });
      } finally {
        this.loading = false;
      }
    },
    resetModal() {
      this.$emit('update:id', null);
      this.$validator.reset();

      this.form = {
        link: '',
        content: null,
        module: null,
        tags: [],
        eventType: null,
        eventDate: null,
        eventTime: null,
        accountId: null,
        doctorTitle: '',
        title: '',
        status: null,
        infoLink: '',
        restrictedCampaign: null,
      };

      this.position = null;
      this.file = null;
      this.preview = null;
      this.fileBanner = null;
      this.previewBanner = null;
      this.address = null;
      this.originalAccountId = null;
      this.eventJoinCount = 0;
      this.justCreatedId = null;
    },

    handleCancel() {
      this.resetModal();
      this.$bvModal.hide('event-modal');
    },
    copyInfoLink() {
      navigator.clipboard
        .writeText(this.form.infoLink)
        .then(() => {
          this.$toastr.s({
            title: 'Thành công',
            msg: 'Đã copy link',
          });
        })
        .catch((err) => {
          console.error('Failed to copy: ', err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 150px;
  height: 150px;
  background-color: #f3f6f9;
  box-shadow: 0px 4px 4px 0px #000000 10%;
  position: relative;
  margin: auto;
}
.icon-edit {
  z-index: 100000;
  position: absolute;
  top: -30px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
</style>
